import styled from 'styled-components'
import { useLearningStats } from 'querys/course'
import LoadingState from 'common/loading-state'
import PortfolioProgress from './portfolio-progress'
import PortfolioCompleted from './portfolio-completed'
import LastCourse from './last-course'
import ProjectsInProgress from './projects-in-progress'
import WeeklPodium from './weekly-podium'

const LearningPlanProgressStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  max-inline-size: 384px;
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;
  margin-block: 2rem;
  &.mobile-visible {
    display: flex;
  }
  .progress-item {
    border: 2px solid var(--neutral40);
    border-radius: 24px;
    padding: 1.5rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
  .btn-container {
    display: flex;
    flex-direction: column;
    gap: .5rem;
    width: 100%;
  }
  @media (min-width: 1024px) {
    margin-block: 2rem;
  }
`

function LearningPlanProgress() {
  const { data, isLoading, isError } = useLearningStats()

  if (isLoading) {
    return (
      <LearningPlanProgressStyled>
        <LoadingState height="500" />
      </LearningPlanProgressStyled>
    )
  }

  if (isError) return null

  const { portfolio } = data || {}
  const portfolioCompleted = portfolio?.curriculum && portfolio?.testimonies && portfolio?.social_media && portfolio?.projects >= 4

  return (
    <LearningPlanProgressStyled id="learning-plan-progress">
      <PortfolioProgress {...data?.portfolio} />
      <LastCourse course={data?.last_course} lesson={data?.last_lesson} />
      <ProjectsInProgress projects={data?.projects} total={data?.total_projects} completed={data?.projects_completed} />
      <WeeklPodium />
      {portfolioCompleted ? (
        <PortfolioCompleted />
      ) : null}
    </LearningPlanProgressStyled>
  )
}

export default LearningPlanProgress
